var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-main',[_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{attrs:{"xs":20,"sm":16,"md":14,"lg":10,"xl":8}},[_c('h1',[_vm._v("Style Concierge")]),_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }